import HomeComponent from "@/components/dashboard/home/home";
import useAuthStore from "@/store/auth";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/home")({
	loader: () => {
		const user = useAuthStore.getState().user;
		if (!user) {
			throw redirect({
				to: "/sign-in"
			});
		}
		if (user.userType !== "VENDOR") {
			throw redirect({
				to: "/buyer/home"
			});
		}
	},
	component: RouteComponent
});

function RouteComponent() {
	const navigate = useNavigate();
	const user = useAuthStore(state => state.user);

	if (!user) {
		return navigate({ to: "/sign-in" });
	}

	return <HomeComponent />;
}
